export const EMAIL_REGEXP = '^[\\w.%+\\-]+@[\\w.\\-]+\\.[A-Za-z]{2,}$';
